import { POPULATION_TYPE } from "@/common/models";

export type FamiliarityStatus =
  | "trusted"
  | "untrusted"
  | "trustedAsViewerOnly"
  | "unmanaged";

export type FamiliarityLevel = "none" | "anomaly" | "new" | "normal" | "strong";

export const FamiliarityLevelColors: Record<FamiliarityLevel, string> = {
  anomaly: "--gray-700",
  new: "--level-l",
  none: "--gray-500",
  normal: "--primary",
  strong: "--main-1",
};

export type FamiliarityEntityType =
  | POPULATION_TYPE.EMPLOYEE
  | POPULATION_TYPE.ORGANIZATION
  | POPULATION_TYPE.PRIVATE_EMAIL
  | POPULATION_TYPE.DEPARTMENT;

export interface FamiliarityItem {
  // entityId
  entityId: string;
  internalEntityId: string;
  labelId: string;
  email: string;
  addedAt: string;
  score: number;
  exposer_balance: {
    from: number;
    to: number;
  };
  firstEventAt: string;
  lastEventAt: string;
  eventCount: number;
  level: FamiliarityLevel;
  // userSetLabelId
  status: FamiliarityStatus;
  // runtime score => affinity
  affinity: number; // 0 - 25
}
